<template>
    <div class="page_content folder_list" v-if="permission && permission.version === '5'">

		<div class="row page-heading mx-0">
			<div class="col-8 input module_heading" role="heading" aria-level="1">
				<span class="module_icon fas fa-folder"></span>
				<span class="module_type_name">Folder Management</span>
			</div>
			<div class="col-4 submit btn-container text-right">
				<button type="button" class="btn btn-primary" @click.prevent="create" aria-label="create" :disabled="permission.systemPermission.readOnly">create</button>
			</div>
		</div>

        <div class="folder-management-section" v-if="isDataSetupFromServer">
            <div class="page_subheading">
              <div class="toolbar-right ui-list-toolbar">
                <select v-model="perPage" aria-label="page size" class="page_size">
                  <option v-for="option in pageOptions" v-bind:value="option">
                    {{ option }}
                  </option>
                </select>
                <div class="btn_container pagination_sty3">
                  <b-pagination
                    align="center"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    :limit="1"
                    :hide-goto-end-buttons="true"
                    :label-prev="$t('previousPage')"
                    :label-next="$t('nextPage')">
                    <template #prev-text>
                      <span class="ic2_arr_pre3" aria-hidden="true"></span>
                    </template>
                    <template #next-text>
                      <span class="ic2_arr_next3" aria-hidden="true"></span>
                    </template>
                  </b-pagination>
                </div>
                <div class="search-box-container">
                  <input type="text" class="input-search" v-model="filter" placeholder="search by folder name" aria-label="search by folder name">
                  <button type="button" class="btn btn_srh" aria-label="search folders">
                    <span class="ic_srh ic_search" aria-hidden="true"></span>
                  </button>
                </div>
              </div>
            </div>

            <b-container fluid>
                <b-row>
                    <b-table bordered :isRowHeader="true" :head-variant="'light'" :items="items"  :fields="fields"
                        :current-page="currentPage" :per-page="perPage" :filter="filter" @filtered="onFiltered" class="folder-management-table">

                        <template slot="name" slot-scope="row">
                            {{row.value}}
                        </template>
                        <template slot="actions" slot-scope="row">
                            <template v-if="permission.systemPermission.readOnly">
                                <span class="action-link icon-pencil mr-2" @click="editFolder(row.item)" aria-label="edit" tabindex="0" style="pointer-events: none; color: #ccc;"></span>
                                <template v-if="isDeleteActionAllowed(row.item.uuid, row.item.ownerId)">
                                    <span class="action-link icon-bin" @click="showDeleteFolderConfirmBox(row.item)" aria-label="delete" tabindex="0" style="pointer-events: none; color: #ccc;"></span>
                                </template>
                            </template>
                            <template v-else>
                                <span class="action-link icon-pencil mr-2" @click="editFolder(row.item)" aria-label="edit" tabindex="0"></span>
                                <template v-if="isDeleteActionAllowed(row.item.uuid, row.item.ownerId)">
                                    <span class="action-link icon-bin" @click="showDeleteFolderConfirmBox(row.item)" aria-label="delete" tabindex="0"></span>
                                </template>
                            </template>
                        </template>
                    </b-table>

                    <template v-if="shouldShowNoResultFound">
                        <span class="no-result">No Results Found</span>
                    </template>

                </b-row>


            </b-container>
        </div>

        <div>
            <b-modal class="delete-folder-popup" ref="deleteFolderModal" :title="'Please Confirm!'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
                <div>
                    <span>{{ folderDeleteMessage }}</span>
                </div>
              <div slot="modal-header" class="popover-header">
                <div class="popup-heading">Please Confirm!</div>
                <button class="btn_close" aria-label="close" @click="hideDeleteConfirmBox">
                    <span class="ic-close"></span>
                </button>
              </div>
              <div slot="modal-footer" class="w-100">
                  <b-button @click="deleteFolderAndHideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="yes"> yes </b-button>
                  <b-button @click="hideDeleteConfirmBox" class="btn button-primary float-right mr-2" aria-label="no"> no </b-button>
              </div>
            </b-modal>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
  import '../../../assets/module/css/folderManagement/folderList.min.css'
  import { mapActions, mapState } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'folder-list',
    data () {
      return {
        items: [],
        fields: [
          {key: 'name', label: 'Folder Name', class: 'first-column'},
          {key: 'actions', label: 'Actions', class: 'second-column text-center'}
        ],
        totalRows: 0,
        folderToDelete: '',
        folderDeleteMessage: '',
        isDataSetupFromServer: false,
        currentPage: 1,
        perPage: 10,
        pageOptions: [ 10, 50, 100 ],
        filter: '',
        shouldShowNoResultFound: false
      }
    },

    mounted () {
      this.loadPermission().then(res => {
        this.$refs.loadingModal.show()
        setTimeout(() => {
          this.loadFoldersWithOwner()
        }, 500)
      })
    },

    methods: {
      ...mapActions([
        'deleteSeletedPrivateFolder',
        'loadPrivateFoldersWithOwner',
        'loadPermission'
      ]),

      loadFoldersWithOwner () {
        this.loadPrivateFoldersWithOwner().then(res => {
          this.items = _.orderBy(res, ['name'], ['asc'])
          this.totalRows = this.items.length
          this.isDataSetupFromServer = true
          this.$refs.loadingModal.hide()
        })
      },

      create () {
        return this.$router.push({name: 'folderCreate'})
      },

      isDeleteActionAllowed (uuid, ownerId) {
        var userObj = JSON.parse(localStorage.getItem('userobj'))
        if (ownerId !== userObj.uuid) {
          return false
        }
        return (uuid !== userObj.personalLearningSpaceUUID)
      },

      editFolder (folder) {
        return this.$router.push({name: 'folderEdit', params: {uuid: folder.uuid, ownerId: folder.ownerId, title: folder.name}})
      },

      showDeleteFolderConfirmBox (folder) {
        this.folderToDelete = folder
        this.folderDeleteMessage = 'Deleting a folder deletes all its contents. Are you sure you want delete folder "' + folder.name + '".'
        this.$refs.deleteFolderModal.show()
      },

      hideDeleteConfirmBox () {
        this.$refs.deleteFolderModal.hide()
      },

      deleteFolderAndHideDeleteConfirmBox () {
        this.hideDeleteConfirmBox()
        this.$refs.loadingModal.show()
        this.deleteSeletedPrivateFolder(this.folderToDelete.uuid).then(res => {
          setTimeout(() => {
            this.loadFoldersWithOwner()
            this.$refs.loadingModal.hide()
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Private folder "' + this.folderToDelete.name + '" deleted successfully.'
            })
          }, 1000)
        })
      },

      onFiltered (filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
        if (filteredItems.length === 0) {
          this.shouldShowNoResultFound = true
        } else {
          this.shouldShowNoResultFound = false
        }
      }
    },
    computed: {
      ...mapState({
        'permission': state => state.user.permission
      })
    }
  }
</script>

<style scoped>
    .heading {
        font-size: 22px;
        font-weight: 400;
        margin-bottom: 8px;
        height: 42px;
    }

    .action-link {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/app/folderManagement/components/FolderList.vue